import { Card, Table, Button } from 'react-bootstrap';

function ManageUsers() {
  return (
    <Card className="shadow-sm p-4">
      <h4>Manage Users</h4>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>User Name</th>
            <th>Role</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Staff Member</td>
            <td>Staff</td>
            <td><Button size="sm">Edit</Button></td>
          </tr>
          <tr>
            <td>2</td>
            <td>Student User</td>
            <td>Student</td>
            <td><Button size="sm">Edit</Button></td>
          </tr>
        </tbody>
      </Table>
    </Card>
  );
}

export default ManageUsers;
